import styled from "styled-components";
import {
  space,
  SpaceProps,
  color,
  ColorProps,
  layout,
  LayoutProps,
  flexbox,
  FlexboxProps,
  border,
  BorderProps,
  typography,
  TypographyProps,
  position,
  PositionProps,
  GridProps,
  grid,
} from "styled-system";

const Box = styled.div<
  SpaceProps &
    ColorProps &
    LayoutProps &
    FlexboxProps &
    BorderProps &
    TypographyProps &
    PositionProps &
    GridProps
>(
  {
    boxSizing: "border-box",
    minWidth: 0,
  },
  space,
  color,
  layout,
  flexbox,
  border,
  typography,
  position,
  grid
);

export default Box;
